import { render, staticRenderFns } from "./TicketsListQuality.vue?vue&type=template&id=5c529487&"
import script from "./TicketsListQuality.vue?vue&type=script&lang=js&"
export * from "./TicketsListQuality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports